import dayjs from 'dayjs'

export const validateDate = async (
    value: string,
    lable?: string
): Promise<any> => {
    if (value?.trim()?.length === 0) {
        await Promise.resolve()
        return // Allow empty values (optional)
    }
    const formattedDate = dayjs(value)?.format('DD/MM/YYYY')
    let datestring = ''
    if (value?.length === 10) {
        datestring = value
    } else {
        datestring = formattedDate
    }

    // Check if input contains any non-numeric characters (excluding "/")
    if (!/^\s*\d{1,2}\/\d{1,2}\/\d{4}\s*$/.test(datestring)) {
        return await Promise.reject(
            new Error('Invalid date format! Use DD/MM/YYYY.')
        )
    }
    // Extract day, month, and year
    const [day, month, year] = datestring.split('/').map(Number)

    // Validate format strictly using Day.js
    const parsedDate = dayjs(datestring, 'DD/MM/YYYY', true)

    // Validate day
    if (day < 1 || day > 31) {
        return await Promise.reject(
            new Error('Invalid day! Day should be between 1 and 31.')
        )
    }

    // Validate month
    // if (month < 01 || month > 12) {
    //     return await Promise.reject(
    //         new Error('Invalid month! Month should be between 1 and 12.')
    //     )
    // }

    // Validate year (you can adjust the range as needed)
    if (year < 1000 || year > 9999) {
        return await Promise.reject(
            new Error('Invalid year! Year should be between 1000 and 9999.')
        )
    }
    if (!parsedDate.isValid()) {
        return await Promise.reject(
            new Error('Invalid date! Please enter a valid date.')
        )
    }
    // Check if day exists in the given month (e.g., no 30th February)
    if (day > parsedDate.daysInMonth()) {
        return await Promise.reject(
            new Error(
                `Invalid day! ${month}/${year} does not have ${day} days.`
            )
        )
    }

    await Promise.resolve()
}
